<template>
    <DModal
        :title="__('customers.invoices.update_accounting_products', {name: groupName})"
        :show="showModal"
        is-big
        is-error
        is-confirm
        :disabled-action="confirmDisabled"
        is-awaiting-validation
        @close="closeModal"
        @confirm="onConfirm"
    >
        <DCard
            padding
        >
            <DRow>
                <DCol class="text-modal-message">
                    {{ __('customers.invoices.update_accounting_product_group_modal_message') }}
                </DCol>
            </DRow>
            <DFormRow
                :label="__('settings.list_view.customer-invoice-item-list.id')"
            >
                {{ item.id }}
            </DFormRow>
            <DFormRow
                :label="__('settings.list_view.customer-invoice-item-list.contract_id')"
            >
                {{ item.contract_id }}
            </DFormRow>
            <DFormRow
                :label="__('customers.invoices.accounting_product')"
                :error="errors.invoice_item_id ?? errors.accounting_product_id"
            >
                <DSelect
                    :options="accountingProductOptions"
                    @update:value="accountingProductSelected"
                />
            </DFormRow>
        </DCard>
    </DModal>
</template>
<script setup>

import { ref } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

const emit = defineEmits(['update:showModal'])
const props = defineProps({
    showModal: {
        type: Boolean,
        default: false
    },
    item: {
        type: Object,
        default: () => ({})
    },
    accountingProductOptions: {
        type: Array,
        default: () => ([])
    },
    customerId: {
        type: Number,
        required: true
    },
    invoiceId: {
        type: Number,
        required: true
    },
    groupName: {
        type: String,
        required: true,
        default: () => ('')
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const confirmDisabled = ref(true)
const selectedAccountingProduct = ref(0)
const form = useForm({
    invoice_item_id: 0,
    accounting_product_id: 0
})

function closeModal () {
    emit('update:showModal', false)
}

function accountingProductSelected (value) {
    selectedAccountingProduct.value = value
    confirmDisabled.value = true
    // I put a delay in there so the user does not directly click on the confirm button directly after the selection
    // to prevent accidents by clicking to fast
    setTimeout(function () { confirmDisabled.value = false }, 1000)
}

function onConfirm () {
    form.invoice_item_id = props.item.invoice_item_id ?? props.item.id
    form.accounting_product_id = selectedAccountingProduct.value
    confirmDisabled.value = true

    form.patch(
        route(
            'customers.customers.invoices.items.update-accounting-products',
            {
                customer: props.customerId,
                invoice: props.invoiceId
            }
        ),
        {
            onSuccess () {
                closeModal()
            }
        }
    )
}

</script>
<style scoped lang="scss">
.text-modal-message {
    font-weight: bold;
}
</style>
